const User = () => (
  <>
    <path
      fill="currentColor"
      d="M12 11.385a2.9 2.9 0 0 1-2.119-.882A2.9 2.9 0 0 1 9 8.385q0-1.238.881-2.12A2.9 2.9 0 0 1 12 5.386a2.9 2.9 0 0 1 2.119.88q.88.882.881 2.12 0 1.237-.881 2.118a2.9 2.9 0 0 1-2.119.881m-7 6.192v-.608q0-.62.36-1.159.361-.538.97-.837a14.2 14.2 0 0 1 2.834-1.018q1.417-.34 2.836-.34 1.42 0 2.836.34a14.2 14.2 0 0 1 2.833 1.018q.61.299.97.837.36.54.361 1.16v.607q0 .44-.299.74-.3.299-.74.299H6.04q-.44 0-.74-.3-.3-.299-.299-.739m1 .038h12v-.646q0-.333-.215-.625a1.7 1.7 0 0 0-.593-.494 12.7 12.7 0 0 0-2.546-.916 11.2 11.2 0 0 0-5.292 0q-1.312.318-2.546.916-.379.203-.593.494A1.04 1.04 0 0 0 6 16.97zm6-7.23q.825 0 1.412-.588Q14 9.209 14 8.385q0-.825-.588-1.413A1.93 1.93 0 0 0 12 6.385q-.825 0-1.412.587A1.93 1.93 0 0 0 10 8.385q0 .825.588 1.412.587.587 1.412.587"
    />
  </>
)
export default User
